import { render, staticRenderFns } from "./CardDepartment.vue?vue&type=template&id=4760e634&scoped=true&"
import script from "./CardDepartment.vue?vue&type=script&lang=js&"
export * from "./CardDepartment.vue?vue&type=script&lang=js&"
import style0 from "./CardDepartment.vue?vue&type=style&index=0&id=4760e634&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4760e634",
  null
  
)

export default component.exports